<template>
  <button
      @click="toggleColorMode"
      aria-label="Toggle color mode"
      class="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
  >
    <Icon v-if="colorMode.value === 'dark'" name="heroicons:sun" class="w-6 h-6 blue" />
    <Icon v-else name="heroicons:moon" class="w-6 h-6"/>
  </button>
</template>

<script setup>
const colorMode = useColorMode();

const toggleColorMode = () => {
  colorMode.preference = colorMode.value === 'dark' ? 'light' : 'dark';
};
</script>

<style scoped>
/* Add custom styles if needed */
.blue{
  //background: black;
}
</style>
